// extracted by mini-css-extract-plugin
export default {"zoomControls":"w--z","zoomControlButton":"x--z","zoomBanner":"y--z","bannerButton":"z--z","imageButton":"A--z","zoom":"B--z","zoomContent":"C--z"};